import React from "react";

export default function SessionTrackSelect({sessionTrackFilter, sessionTracks, changeHandler}) {
	return (
		<label>
			Filter sessions by track:
			<select
					id="session-track-select"
					value={sessionTrackFilter}
					onChange={(event) => {
						changeHandler(event.target.value)
					}}
			>
				<option key="select-a-track" value="">-- Select a track --</option>
				{
					Array.from(sessionTracks).map(track => <option key={track} value={track}>{track}</option>)
				}
			</select>
		</label>
	)
}
